import React from 'react';
import { Shield, Lock, Eye, FileText } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-44 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-6" data-testid="privacy-title">
            Gizlilik Politikası & KVKK
          </h1>
          <p className="text-lg text-gray-600">
            Son güncelleme: 1 Kasım 2025
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-6">
          {/* Şirket Bilgileri */}
          <section className="bg-gradient-to-r from-junto-red to-red-700 text-white rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4">Şirket Bilgilerimiz</h2>
            <div className="space-y-2">
              <p><strong>Ticari Ünvan:</strong> Küme Kahve Sanayi İthalat İhracat Ticaret Limited Şirketi</p>
              <p><strong>E-posta:</strong> mehmet@juntokahve.com</p>
              <p><strong>KEP Adresi:</strong> juntokahve@hs03.kep.tr</p>
              <p><strong>MERSİS No:</strong> 0167118788300001</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Kişisel Verilerin Korunması</h2>
            <p className="text-gray-700 leading-relaxed">
              JUNTO® olarak, kişisel verilerinizin güvenliği bizim için son derece önemlidir. 
              6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında, müşterilerimizin 
              kişisel verilerini en üst düzeyde korumak ve gizliliğini sağlamak için gerekli tüm 
              teknik ve idari tedbirleri almaktayız.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">KVKK Hakları</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              KVKK kapsamında sahip olduğunuz haklar:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
              <li>Kişisel verilerin işlenme amacını öğrenme</li>
              <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde düzeltilmesini isteme</li>
              <li>Kişisel verilerin silinmesini veya yok edilmesini isteme</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">İletişim</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verilerinizle ilgili taleplerinizi aşağıdaki iletişim bilgileri üzerinden bize iletebilirsiniz:
            </p>
            <div className="p-6 bg-gray-50 rounded-xl border-l-4 border-junto-red">
              <p className="text-gray-700 mb-2"><strong>E-posta:</strong> mehmet@juntokahve.com</p>
              <p className="text-gray-700"><strong>KEP Adresi:</strong> juntokahve@hs03.kep.tr</p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-6 mt-8">
            <p className="text-sm text-gray-500 text-center">
              Bu belge 6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca hazırlanmıştır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;